import { render, staticRenderFns } from "./OrderDeliveryReport.vue?vue&type=template&id=20b92266&scoped=true&"
import script from "./OrderDeliveryReport.vue?vue&type=script&lang=js&"
export * from "./OrderDeliveryReport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./OrderDeliveryReport.vue?vue&type=style&index=1&id=20b92266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b92266",
  null
  
)

export default component.exports